<template>
    <v-container style="max-width: 1240px" class="pb-5 pt-5">
        <v-content>
            <v-layout
                v-for="(product, index) in products"
                :key="index"
                row
                wrap
                align-center
                class="product-item"
            >
                <!-- Логотип и описание -->
                <v-flex xs12 sm4 md3 lg3 class="pa-3 text-xs-center">
                    <div class="logo-wrapper">
                        <img :src="product.image" alt="offer-logo" class="logo" />
                        <div class="description mt-2">{{ product.name }}</div>
                    </div>
                    <div class="more-details">
                        <v-btn
                            @click="toggleShow(product.id)"
                            text
                            small
                            class="details-btn"
                        >
                            Подробнее
                            <v-icon :class="{ 'rotate': showMore[product.id] }">
                                {{ showMore[product.id] ? 'expand_less' : 'expand_more' }}
                            </v-icon>
                        </v-btn>
                        <div
                            class="details-container"
                            :class="{ 'open': showMore[product.id] }"
                            @click.stop
                        >
                            <div class="details-content">
                                {{ product.description }}
                            </div>
                        </div>
                    </div>
                </v-flex>

                <!-- Основные данные -->
                <v-flex xs12 sm5 md6 lg6 class="pa-3">
                    <div class="data-container">
                        <!-- Фиксированное поле: Вознаграждение -->
                        <div v-if="showCommission">
                            <div
                                v-show="!commissionsHidden"
                                @click="toggleCommissions"
                                class="data-item commission-item color-black tip-icon width-auto"
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                            >
                                <div class="data-label">Вознаграждение, Р</div>
                                <div class="data-value">{{ product.commission ? Number(product.commission).toFixed(0) : '-' }}</div>
                            </div>
                            <div
                                v-show="commissionsHidden"
                                @click="toggleCommissions"
                                class="data-item commission-item color-black tip-icon width-auto"
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Нажмите, чтобы показать вознаграждение"
                            >
                                <div class="data-label">Вернуть</div>
                            </div>
                        </div>

                        <!-- Динамические поля из extra_data -->
                        <template v-for="(value, key) in product.extra_data">
                            <div
                                v-if="value && value.name && value.value"
                                :key="key"
                                class="data-item"
                            >
                                <div class="data-label">{{ value.name }}</div>
                                <div class="data-value">{{ value.value }}</div>
                            </div>
                        </template>
                    </div>
                </v-flex>

                <!-- Кнопка оформления -->
                <v-flex xs12 sm3 md3 lg3 class="pa-3 text-xs-center" v-if="isEditable">
                    <v-btn
                        @click="$emit('select', product)"
                        class="action-btn"
                        block
                    >
                        Оформить
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-content>
    </v-container>
</template>

<script>
export default {
    name: 'BankCardsList',
    props: {
        products: Array,
        isEditable: Boolean,
        showCommission: [Number, Boolean],
    },
    data: () => ({
        showMore: {},
        commissionsHidden: false,
    }),
    methods: {
        toggleShow(id) {
            const newState = !this.showMore[id];
            this.showMore = {}; // Закрываем все открытые контейнеры
            this.$set(this.showMore, id, newState);
        },
        handleClickOutside(event) {
            if (!event.target.closest('.details-container') &&
                !event.target.closest('.details-btn')) {
                this.showMore = {};
            }
        },
        toggleCommissions() {
            this.commissionsHidden = !this.commissionsHidden;
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    updated: () => {
        window.tippy.default('.tip-icon');
    },
}
</script>

<style>
.product-item {
    border-top: 1px solid rgba(0,0,0,0.1);
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding: 32px 0;
    margin: 0 -16px;
    display: flex;
    flex-wrap: wrap;
}

.product-item:first-child {
    border-top: none;
}

.logo-wrapper {
    max-width: 200px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 12px;
}

.logo-wrapper .logo {
    max-width: 100%;
    height: auto;
    margin-bottom: 16px;
    border-radius: 12px;
    display: block;
    object-fit: cover;
}

.logo-wrapper .description {
    font-size: 16px;
    color: #666;
    font-weight: 500;
    line-height: 1.3;
}

.data-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
    width: 100%;
}

.data-item {
    display: flex;
    flex-direction: column;
    padding: 0;
    min-height: auto;
    background: none !important;
    box-shadow: none !important;
    border-radius: 0;
    transition: none;
}

.data-item:hover {
    box-shadow: none !important;
    transform: none !important;
}

.data-item .data-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.data-item .data-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: break-word;
}

.more-details {
    position: relative;
    margin-top: 16px;
}

.more-details .details-btn {
    padding: 0;
    font-size: 16px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    min-width: 0 !important;
    color: #00ba57;
    z-index: 1;
    position: relative;
    font-weight: 500;
}

.more-details .details-btn:hover,
.more-details .details-btn:focus {
    background: transparent !important;
    box-shadow: none !important;
}

.more-details .details-btn::before {
    opacity: 0 !important;
}

.more-details .v-icon {
    margin-left: 8px;
    transition: transform 0.3s ease;
    font-size: 18px;
}

.more-details .v-icon.rotate {
    transform: rotate(180deg);
}

.more-details .details-container {
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    max-height: 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: white;
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    border-radius: 8px;
    overflow: hidden;
    z-index: 2;
}

.more-details .details-container.open {
    opacity: 1;
    visibility: visible;
    max-height: 250px;
    padding: 16px;
}

.more-details .details-content {
    max-height: 200px;
    overflow-y: auto;
    padding-right: 8px;
    line-height: 1.5;
    font-size: 14px;
}

.more-details .details-content::-webkit-scrollbar {
    width: 6px;
}

.more-details .details-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.more-details .details-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.action-btn {
    background: #00ba57 !important;
    color: white !important;
    font-weight: 600;
    letter-spacing: normal;
    text-transform: none;
    padding: 16px !important;
    border-radius: 8px;
    max-width: 200px;
    margin: 0 auto;
    height: auto;
    box-shadow: 0 4px 6px rgba(0, 186, 87, 0.2);
    transition: all 0.3s ease;
}

.action-btn:hover {
    box-shadow: 0 6px 10px rgba(0,186,87,0.3);
    transform: translateY(-2px);
}

/* Адаптивные стили */
@media (max-width: 1080px) {
    .product-item {
        padding: 24px 0;
    }

    .data-container {
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    }

    .action-btn {
        padding: 14px !important;
        font-size: 15px;
    }
}

@media (max-width: 960px) {
    .logo-wrapper {
        max-width: 160px;
    }

    .logo-wrapper .description {
        font-size: 15px;
    }

    .data-container {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 12px;
    }

    .data-item .data-label {
        font-size: 12px;
    }

    .data-item .data-value {
        font-size: 15px;
    }
}

@media (max-width: 768px) {
    .product-item {
        flex-direction: column;
        align-items: center;
    }

    .data-container {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        margin-top: 20px;
    }

    .action-btn {
        margin-top: 20px;
        max-width: 100%;
    }
}

@media (max-width: 600px) {
    .product-item {
        padding: 20px 0;
    }

    .more-details .details-container {
        left: 0;
        transform: translateY(100%);
        width: 100%;
    }

    .more-details .details-container.open {
        transform: translateY(0);
    }

    .data-container {
        grid-template-columns: repeat(2, 1fr);
    }

    .data-item .data-label {
        font-size: 11px;
    }

    .data-item .data-value {
        font-size: 14px;
    }

    .action-btn {
        padding: 12px !important;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .data-container {
        grid-template-columns: 1fr;
    }

    .data-item {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }

    .data-item .data-label {
        margin-bottom: 0;
        margin-right: 10px;
        flex-shrink: 0;
        max-width: 50%;
    }

    .data-item .data-value {
        text-align: right;
        flex-grow: 1;
    }

    .commission-item {
        flex-direction: column;
        align-items: flex-start;
        border-bottom: none;
        padding: 0;
    }

    .commission-item .data-label {
        margin-bottom: 5px;
        margin-right: 0;
        max-width: 100%;
    }

    .commission-item .data-value {
        text-align: left;
    }
}

.tip-icon {
    width: unset;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/bank-products/banking-offers/BankingOffersList.vue